module.exports = __webpack_public_path__ + "static/img/case-mobile-diagram-01.64c1814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-mobile-diagram-01.png
// module id = zR3V
// module chunks = 1